import { render, staticRenderFns } from "./OrderRequest.vue?vue&type=template&id=28617cf8&scoped=true"
import script from "./OrderRequest.vue?vue&type=script&lang=js"
export * from "./OrderRequest.vue?vue&type=script&lang=js"
import style0 from "./OrderRequest.vue?vue&type=style&index=0&id=28617cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28617cf8",
  null
  
)

export default component.exports